// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d247834a","455":"b807900f","488":"c0c1d107","977":"5903b4ae"}[chunkId] + ".chunk.js";
};